<div
  class="custom-mat-form-wrapper"
  [class.compact-field]="compact"
  [class.custom-input-number]="type === 'number'"
  [class.read-only]="readOnly"
>
  <div class="mat-form-label" dojoFormFieldLabel *ngIf="label">
    <ng-container *ngIf="state.labelTemplate; else defaultLabelTmpl">
      <ng-container *ngTemplateOutlet="state.labelTemplate"></ng-container>
    </ng-container>

    <ng-template #defaultLabelTmpl>
      <span>{{ label }}</span>

      @if (tooltipHint) {
        <y42-info-icon [message]="tooltipHint" [infoIconDisabled]="formCtrl.disabled" />
      }
    </ng-template>
  </div>

  <mat-form-field
    class="w-full"
    [ngClass]="'size-' + size()"
    appearance="fill"
    [color]="color"
    [matTooltip]="state.tooltip"
    [class.full-width-field]="fullWidthField"
  >
    <ng-container matPrefix>
      <ng-content select="[y42InputPrefix]"></ng-content>
    </ng-container>

    <!-- https://github.com/angular/angular/issues/13243 -->
    <ng-container *ngIf="type === 'number'">
      <input
        matInput
        type="number"
        [step]="step"
        [min]="min"
        [max]="max"
        [formControl]="formCtrl"
        [placeholder]="placeholder ?? ''"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        [tabIndex]="tabIndex"
        [attr.cdkFocusInitial]="hasInitialFocus"
        [attr.inputmode]="inputmode"
        (input)="input.emit($event)"
        (keyup)="keyup.emit($event)"
        (blur)="blur.emit($event)"
      />
    </ng-container>

    <ng-container *ngIf="type === 'textarea'">
      <textarea
        matInput
        [type]="type"
        [formControl]="formCtrl"
        [placeholder]="placeholder ?? ''"
        [ngClass]="{ '!uppercase': upperCase, 'hide-resize': !resizable }"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        [tabIndex]="tabIndex"
        [attr.cdkFocusInitial]="hasInitialFocus"
        [attr.inputmode]="inputmode"
        [cdkTextareaAutosize]="autoResize"
        [cdkAutosizeMaxRows]="autoResizeMaxRows"
        [cdkAutosizeMinRows]="autoResizeMinRows"
        (input)="input.emit($event)"
        (keyup)="keyup.emit($event)"
        (blur)="blur.emit($event)"
      >
      </textarea>
    </ng-container>

    <ng-container *ngIf="type !== 'number' && type !== 'textarea'">
      <input
        matInput
        [type]="type"
        [formControl]="formCtrl"
        [placeholder]="placeholder ?? ''"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        [tabIndex]="tabIndex"
        [ngClass]="{ '!uppercase': upperCase }"
        [attr.cdkFocusInitial]="hasInitialFocus"
        [attr.inputmode]="inputmode"
        (input)="input.emit($event)"
        (keyup)="keyup.emit($event)"
        (blur)="blur.emit($event)"
      />
    </ng-container>

    <ng-content></ng-content>
    <ng-container matSuffix>
      <ng-content select="[dojoInputSuffix]"></ng-content>
      <ng-container *ngIf="enableCopyToClipboard">
        <dojo-copy-to-clipboard *ngIf="formCtrl.value" [value]="formCtrl.value" />
      </ng-container>
    </ng-container>
    <mat-error *ngIf="!hideErrors && state.errorMessage">
      {{ state.errorMessage }}
    </mat-error>
  </mat-form-field>
</div>
